export async function useFetchSocialMedias() {
  const { data: socialMedias } = await useFetch<SocialMedia[]>(
    '/api/social-medias',
    {
      baseURL: useRuntimeConfig().public.cms,
      query: {
        populate: 'deep',
      },
      key: 'dbc-social-medias',
      transform: (response: any) => {
        return response.data
      },
    }
  )
  return socialMedias
}
